import {BackendApi} from "./httpClient/backendApi";
import {Event} from "../../store/models";

export const getEvent = async (eventId: string): Promise<Event | null> => {
    const response = await BackendApi.getInstance().instance
        .get<{ event: Event }>(
            `/events/${eventId}`,
        );

    if (!response.data) {
        return null;
    }

    return response.data.event;
}
